// src/components/StatusBadge.jsx — Reusable status badge
import React from 'react';

const STATUS_CONFIG = {
  'New':             { cls: 'badge-new',           label: 'New' },
  'Follow-up':       { cls: 'badge-followup',       label: 'Follow-up' },
  'In Conversation': { cls: 'badge-conversation',   label: 'In Conversation' },
  'Customer':        { cls: 'badge-customer',       label: 'Customer' },
  'Not Interested':  { cls: 'badge-not-interested', label: 'Not Interested' },
};

/**
 * StatusBadge — consistent status pill used across Leads grid and Lead Detail.
 * @param {string} status - one of LEAD_STATUSES
 * @param {string} [size] - 'sm' | 'md' (default 'md')
 */
export default function StatusBadge({ status, size = 'md' }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['New'];
  return (
    <span
      className={`status-badge ${config.cls}`}
      style={{ fontSize: size === 'sm' ? '11px' : '12px' }}
    >
      {config.label}
    </span>
  );
}

export { STATUS_CONFIG };
